import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { HasRolePipe } from 'src/api-authorization/has-role.pipe';
import { PaginatorComponent } from './paginator/paginator.component';

@NgModule({
  declarations: [
    HasRolePipe,
    PaginatorComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    NgbModule
  ],
  exports: [
    HasRolePipe,
    PaginatorComponent,
    FontAwesomeModule,
    NgbModule
  ]
})
export class SharedModule { }
